import BaseApiService from "api/BaseApiService";
import Config from "configs/Config";
import { JwtPair } from "models/AuthFactory/accessToken";
import { UserEntity } from "models/AuthFactory/user";

type IPresignResponse = {
	jwtPair: JwtPair;
};

type IPostSignin = {
	oAuthToken: string;
};

type ISignInResponse = {
	user: UserEntity;
	jwtPair: JwtPair;
};

type ISignOutResponse = {
	jwtPair: JwtPair;
};

export default class AuthApi extends BaseApiService {
	private static instance: AuthApi;
	private readonly baseUrl = this.authFactoryUrl.concat("/app-auth/").concat(Config.getInstance().get().app);

	private constructor() {
		super();
	}

	public static getInstance(): AuthApi {
		return (this.instance = this.instance ?? new AuthApi());
	}

	public async presign(): Promise<IPresignResponse> {
		const url = new URL(this.baseUrl.concat("/presign"));
		try {
			return await this.postRequest<IPresignResponse>(url);
		} catch (err) {
			this.onError(err);
			return Promise.reject(err);
		}
	}

	public async signIn(): Promise<ISignInResponse> {
		const url = new URL(this.baseUrl.concat("/sign-in"));
		try {
			return await this.postRequest<ISignInResponse>(url);
		} catch (err) {
			this.onError(err);
			return Promise.reject(err);
		}
	}

	public async signInWithOAuth(params: IPostSignin): Promise<ISignInResponse> {
		const url = new URL(this.baseUrl.concat("/sign-in-o-auth"));
		try {
			return await this.postRequest<ISignInResponse>(url, params);
		} catch (err) {
			this.onError(err);
			return Promise.reject(err);
		}
	}

	public async signOut(): Promise<ISignOutResponse> {
		const url = new URL(this.baseUrl.concat("/sign-out"));
		try {
			return await this.patchRequest<ISignOutResponse>(url);
		} catch (err) {
			this.onError(err);
			return Promise.reject(err);
		}
	}
}
